import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/nf/ncms/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findNcm(empresa_cnpj, where = {}, includes = "") {
  let query = "";
  Object.keys(where).forEach((value, index) => {
    query += `&where[${value}]=${where[value]}${
      includes ? `&include=${includes}` : ""
    }`;
  });
  return search(`${path}?empresa_cnpj=${empresa_cnpj}${query}`, "GET", headers);
}
